import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modal-onboarding-video",
  class: "modal modal-md fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}

import { Modal } from 'bootstrap'
  import { ref, onMounted } from 'vue'
  import useSawNewsStore from '../store/pinia/useSawNews.store'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalOnboardingVideo',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const player = ref<HTMLIFrameElement | null>(null)
  const sawNewsStore = useSawNewsStore()

  function stopVideo() {
    player.value?.contentWindow?.postMessage(
      '{"event":"command","func":"stopVideo","args":""}',
      '*',
    )
  }

  function playVideo() {
    player.value?.contentWindow?.postMessage(
      '{"event":"command","func":"playVideo","args":""}',
      '*',
    )
  }

  onMounted(() => {
    modal.value = new Modal('#modal-onboarding-video', {
      backdrop: 'static',
      keyboard: false,
    })

    player.value = document.getElementById('player') as HTMLIFrameElement
    stopVideo()
  })

  function show() {
    modal.value?.show()
    playVideo()
  }

  function hide() {
    stopVideo()
    sawNewsStore.setSawNews()
    modal.value?.hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "modal-dialog modal-dialog-centered" }, [
      _createElementVNode("div", { class: "modal-content mb-3" }, [
        _createElementVNode("div", { class: "modal-header pb-0 pt-4 ps-3 pe-4" }, [
          _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title plugin-modal-title" }, "Temos novidade!", -1)),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: hide
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body px-1" }, [
          _createElementVNode("p", { class: "fs-6 text-start px-3" }, [
            _createTextVNode(" A partir de agora, "),
            _createElementVNode("strong", null, " você pode escolher cadastrar uma senha para usar seu Certificado Digital ."),
            _createTextVNode(" Veja como funciona no vídeo abaixo: ")
          ]),
          _createElementVNode("iframe", {
            id: "player",
            src: "https://www.youtube.com/embed/QuoiuQeDFFc?mute=1&rel=0&showinfo=0&enablejsapi=1",
            title: "YouTube video player",
            frameborder: "0",
            allowfullscreen: ""
          })
        ], -1))
      ])
    ])
  ]))
}
}

})